module.exports = __webpack_public_path__ + "images/accents/accent-sl3-efficiency-ced113d3857d894c6a3f27dcce320bbd.webp";